import logo from "../../assets/svg/logo.svg";
import styled from "styled-components";
import colours from "../../lib/colours";
import { AppName } from "../../lib/constants";
import { Link } from "react-router-dom";
import appConfig from "../../lib/appConfig";

const HeaderContainer = styled.header`
  background-color: ${colours.th1};
  height: ${appConfig.headerHeight}px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  color: white;
  padding-inline: 25px;
  align-items: center;
  @media (max-width: ${appConfig.smallMobileWidth}px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const Logo = styled.img`
  height: 50px;
  @media (max-width: ${appConfig.mobileWidth}px) {
    height: 40px;
  }
`;

const HomeLink = styled(Link)`
  margin: auto;
  padding-inline: 20px;
  font-size: 26px;
  font-weight: 600;
  color: ${colours.white};
  text-decoration: none;
  @media (max-width: ${appConfig.tabletWidth}px) {
    font-size: 22px;
  }
  @media (max-width: ${appConfig.mobileWidth}px) {
    font-size: 18px;
  }
`;

function Header() {
  return (
    <HeaderContainer>
      <a
        href="https://deeca.vic.gov.au"
        target="_blank"
        title="Department of Energy, Environment and Climate Action"
        rel="noopener noreferrer"
      >
        <Logo
          src={logo}
          alt="Department of Energy, Environment and Climate Action Logo"
        />
      </a>

      <HomeLink to="/" title="Home - NVR Map">
        {AppName}
      </HomeLink>
    </HeaderContainer>
  );
}

export default Header;
